module.exports = __webpack_public_path__ + "static/media/bannerimg.07d99dba.jpeg";